import React from 'react';
import { Box, Typography } from '@mui/material';

interface SettingsSectionHeaderProps {
  title: string;
  description: string;
}

export const SettingsSectionHeader: React.FC<SettingsSectionHeaderProps> = ({
  title,
  description,
}) => (
  <Box className="mb-5">
    <Typography variant="h6" className="font-semibold text-gray-900 dark:text-slate-100">
      {title}
    </Typography>
    <Typography variant="body2" className="mt-1 text-gray-600 dark:text-slate-400">
      {description}
    </Typography>
  </Box>
);
